import Vue from 'vue';

// 기존에는 store/modules/callWebsockt/index.js 파일에 들어있던 로직이었으나,
// klcns(웹콜)전용 로직을 분리하면서 파일을 따로 분리함.

const state = {
  isFirstConnect: true,
  isCallSocketReConnected: false,
  isSocketReconnectFail: false,
  reconnectToast: [],
  isOffline: false
};

const getters = {
  IS_OFFLINE: (state) => {
    return state.isOffline;
  },
  isCallSocketReConnected: (state) => {
    return state.isCallSocketReConnected;
  },
  isFirstConnect: (state) => {
    return state.isFirstConnect;
  }
};

const mutations = {
  setIsFirstConnect(state, payload) {
    state.isFirstConnect = payload;
  },
  setIsSocketReconnectFail(state, payload) {
    state.isSocketReconnectFail = payload;
  },
  setReconnectToast(state, payload) {
    const { message, duration } = payload;
    state.reconnectToast.push(Vue.toasted.error(message), { duration: duration });
  },
  setIsCallSocketReConnected(state, payload) {
    state.isCallSocketReConnected = payload;
  },
  setIsOffline(state, payload) {
    state.isOffline = payload;
  }
};

const actions = {
  checkShowNotify({ rootState }) {
    // 외부 사용 X
    const { enabledCallAgent, isExistCallAgent } = rootState.callWebsocket;
    if (enabledCallAgent && isExistCallAgent) {
      return true;
    }
    return false;
  },
  notifySocketReconnection({ commit, dispatch }) {
    // 외부 사용 O
    if (!dispatch('checkShowNotify')) {
      return;
    }
    // 콜 소켓 연결이 끊어지면 재연결 토스트를 띄운다.
    dispatch('removeBeforeNotify');
    const payload = {
      message: '콜 서버에 연결할 수 없습니다. 다시 시도 중입니다.',
      duration: null
    };
    commit('setReconnectToast', payload);
  },
  removeBeforeNotify({ state, commit, dispatch }) {
    // 외부 사용 O
    if (!dispatch('checkShowNotify')) {
      return;
    }
    // 소켓 재연결 실패의 경우, 바로 재시도하기 때문에 이전에 띄웠던 토스트는 지우고 재시도 팝업 띄워야함
    if (state.isSocketReconnectFail) {
      commit('setIsSocketReconnectFail', false);
      dispatch('removeNotifySocketReconnection');
    }
  },
  removeNotifySocketReconnection({ commit, dispatch }) {
    // 외부 사용 X
    if (!dispatch('checkShowNotify')) {
      return;
    }
    // 소켓 재연결 실패, 완료 시 소켓 재연결 시도중 팝업 지우기
    if (state.reconnectToast.length > 0) {
      state.reconnectToast.forEach((toastObj, index) => {
        if (toastObj.goAway) {
          toastObj.goAway(0);
        }
        state.reconnectToast.splice(index, 1);
      });
    }
    commit('initDimmed', null, { root: true });
  },
  notifySocketReconnectionFail({ commit, dispatch }) {
    // 외부 사용 O
    if (!dispatch('checkShowNotify')) {
      return;
    }
    // 소켓 재연결 실패
    if (state.isCallSocketReConnected) {
      commit('setIsCallSocketReConnected', true);
    }
  },
  notifySocketReconnectionSuccess({ dispatch }) {
    // 외부 사용 O
    if (!dispatch('checkShowNotify')) {
      return;
    }
    // 소켓 재연결 성공
    if (state.isCallSocketReConnected) {
      Vue.toasted.success('콜 서버에 재 연결되었습니다.', {
        onComplete: () => {
          dispatch('removeNotifySocketReconnection');
        }
      });
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/callWebsocket/reconnect.js